import { apiRequest } from '@/Groups/Signals/private/imports/externalUtils';

const BASE = '/api/signals';

//Получить все сигналы (с поддержкой пагинации)
export const apiGetSignals = (nextUrl = null) =>
  apiRequest(nextUrl ?? `${BASE}/`);

//Получить сигналы по фильтру
export const apiGetSignalsFiltered = (filterName, nextUrl = null) =>
  apiRequest(nextUrl ?? `${BASE}/?filter=${filterName}`);

//Получить сигналы с сортировкой
export const apiGetSignalsSorted = (sortKey, direction = 'desc', nextUrl = null) =>
  apiRequest(nextUrl ?? `${BASE}/?sort_${sortKey}=${direction}`);

//Получить один сигнал по id
export const apiGetSignalById = (id) =>
  apiRequest(`${BASE}/${id}/`);

//Создать новый сигнал
export const apiCreateSignal = (formData) =>
  apiRequest(`${BASE}/`, { method: 'POST', body: formData });

//Обновить существующий сигнал
export const apiUpdateSignal = (id, formData) =>
  apiRequest(`${BASE}/${id}/`, { method: 'PATCH', body: formData });

//Закрепить / открепить сигнал
export const apiTogglePinSignal = (id, method) =>
  apiRequest(`${BASE}/pin/${id}/`, { method });

//Получить актуальные цены по списку id
export const apiGetSignalPrices = (idString) =>
  apiRequest(`${BASE}/check-price/?list_id=${idString}`);

//Проверить наличие новых обновлений с заданного времени
export const apiCheckSignalUpdates = (datetime) =>
  apiRequest(`${BASE}/check-update/?datetime=${datetime}`);